import { Routes, Route } from 'react-router-dom';
import { SplashScreen } from '../pages/SplashScreen.js';
import { LoginScreen } from '../pages/LoginScreen.js';
import { HomeScreen } from '../pages/HomeScreen.js';
import { WaitingRoomScreen } from '../pages/WaitingRoomScreen.js';
import { RoomHubScreen } from '../pages/RoomHubScreen.js';
import { LiveGameScreen } from '../pages/LiveGameScreen.js';
import { GameResultsScreen } from '../pages/GameResultsScreen.js';
import { MatchHistoryScreen } from '../pages/MatchHistoryScreen.js';
import { ProfileSettingsScreen } from '../pages/ProfileSettingsScreen.js';
import { HelpScreen } from '../pages/HelpScreen.js';

/**
 * App Router
 * Routes will be added as screens are built in future phases.
 */
export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/home" element={<HomeScreen />} />
      <Route path="/waiting-room" element={<WaitingRoomScreen />} />
      <Route path="/create-room" element={<RoomHubScreen />} />
      <Route path="/join-room" element={<RoomHubScreen />} />
      <Route path="/rooms" element={<RoomHubScreen />} />
      <Route path="/game" element={<LiveGameScreen />} />
      <Route path="/results" element={<GameResultsScreen />} />
      <Route path="/match-history" element={<MatchHistoryScreen />} />
      <Route path="/settings" element={<ProfileSettingsScreen />} />
      <Route path="/help" element={<HelpScreen />} />
      <Route
        path="*"
        element={
          <div className="flex h-screen items-center justify-center">
            <p className="text-surface-400">404 – Page not found</p>
          </div>
        }
      />
    </Routes>
  );
}
